import React, {useEffect, useState, createContext} from "react";
import {fetchJson} from "../fetch.js";
import * as BookPageHelpers from './helpers.js';
import * as Helpers from '../helpers.mjs';
import LoadingSpinner from '../components/loadingSpinner.mjs';
import { useExtraData} from "./DataContext.js";

const BestsellerBadge = ({productId, small}) => {
    
    let { bestsellersData } = useExtraData();

    const bestsellerArray = bestsellersData.filter(bs => bs.product == productId);
    const positions = bestsellerArray.map(bs => bs.rank).sort(function(a, b){return a-b});
    const bestseller = bestsellerArray.find(bs => bs.rank == positions[0]);


    // Book page html
    useEffect(() => {

            // Load product data
            // Cleaning up
            // return () => {
                
            // };
        }, []
    );

    if (!bestseller) {
        return null;
    }
    return (
        <p className={'bestSellersTitle carouselBadgeHeader productBadge'+(small ? ' searchBadge' : '')} title={'Highest position: #' + bestseller.rank + ' on ' + bestseller.startDate}>
            <i class='fas fa-chart-line'></i>{(!small ? <span><strong>Bestseller</strong></span> : "")}
        </p>
    )
}

export default BestsellerBadge;